import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length) return null;
  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="daylight-work-surface grid gap-10 rounded-[28px] p-7 lg:grid-cols-12 lg:gap-8 lg:p-12">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:col-span-4 lg:py-6"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="rounded-[22px] bg-daylight p-6 lg:col-span-7 lg:col-start-6 lg:p-10">
          <FormPanel
            errorMessage={errorMessage}
            fields={fields}
            submitLabel={submitLabel}
            successMessage={successMessage}
          />
        </div>
      </div>
    </DaylightSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
